import apiClient from '../../../shared/services/apiHelper';

export const clientService = {
    registerClient: async (payload) => {
        try {
            const formData = new FormData();
            Object.entries(payload).forEach(([key, value]) => {
                formData.append(key, value ?? '');
            });
            return await apiClient.client.post('register/register-client', formData);
        } catch (error) {
            console.error('clientService.registerClient error:', error);
            throw error;
        }
    },

    /**
     * Verify organization details using a token
     * @param {string} token - Organization hash token
     * @returns {Promise} - API response
     */
    verifyOrganization: async (token) => {
        try {
            return await apiClient.get(`/register/client/${token}`);
        } catch (error) {
            console.error('clientService.verifyOrganization error:', error);
            throw error;
        }
    }
};
